import React from 'react';
import {withRouter} from 'react-router-dom';

import {Button} from 'reactstrap';
import {ListItemIcon, ListItemText, Menu, MenuItem} from '@material-ui/core';

import LogOutIcon from '@material-ui/icons/ExitToApp';
import SignupNotifications from './SignupNotifications';
import PersonIcon from '@material-ui/icons/PersonOutline';

import Framework from '@beardeddevops/react.framework';
import {API} from "@beardeddevops/react.api";
import Lockable from "components/Lockable";
import Types from "../../constants/Types";

class NavRightList extends Lockable {

	constructor(props) {
		super(props);
		this.state.anchorEl = null;
		this.model = new API.BuildClass(Types.Accounts._name, API.RequestType.READ);
	}

	handleRoute = (value) => () => {
		this.props.history.push(value);
		this.setState({anchorEl: null});
	};

	handleOpen = event => {
		this.setState({anchorEl: event.currentTarget});
	};

	handleClose = () => {
		this.setState({anchorEl: null});
	};

	handleLogout = async (event) => {
		if (typeof event !== 'undefined') event.preventDefault();
		await this.model.submit(null, API.RequestType.DELETE, false, false, false, true);
		this.props.rootState.triggerAction('logout');
		return false;
	}

	render() {
		const {anchorEl} = this.state;
		const {name} = this.props;
		return (
			<ul className="list-unstyled float-right">
				<li style={{marginRight: '10px'}}>

					<SignupNotifications history={this.props.history}/>
					<Button
						aria-owns={anchorEl ? 'user-menu' : null}
						aria-haspopup="true"
						onClick={this.handleOpen}
						className="md-button header-btn menu-button"
						color={'none'}
					>
						<PersonIcon/>
						<span>{name}</span>
						<i className={'fa fa-angle-down'}/>
					</Button>
					<Menu
						id="user-menu"
						anchorEl={anchorEl}
						open={Boolean(anchorEl)}
						onClose={this.handleClose}
						getContentAnchorEl={null}
						anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
						transformOrigin={{horizontal: 'right', vertical: 'top'}}
					>
						<MenuItem onClick={this.handleRoute('/two_step')}>
							<ListItemIcon><i className={"fa fa-lock fa-lg"}/></ListItemIcon>
							<ListItemText inset primary="Two Step Auth"/>
						</MenuItem>
						<MenuItem onClick={async () => { await API.clearCache(); this.setState({anchorEl: null}); }}>
							<ListItemIcon><i className={'fa fa-refresh fa-lg'}/></ListItemIcon>
							<ListItemText inset primary="Clear Cache"/>
						</MenuItem>
						<MenuItem onClick={this.handleLogout}>
							<ListItemIcon>
								<LogOutIcon/>
							</ListItemIcon>
							<ListItemText inset primary="Logout"/>
						</MenuItem>
					</Menu>

					<Button onClick={this.handleLogout} data-id={'logout-button'} color={'none'} className="md-button header-btn">
						<LogOutIcon/>
					</Button>
				</li>
			</ul>
		);
	}
}

export default Framework.Components.withRootState(withRouter(NavRightList));
